// // // import React, { useState } from "react";
// // // import "../../css/DermReportSection.css";
// // // import { useAuth } from "../../context/AuthContext";
// // // import api from "../../api/axiosConfig";

// // // interface Props {
// // //   emrId: string;
// // //   patientAge: number;
// // //   doctorName: string;
// // //   userId: string;

// // //   // 🔥 ADD THIS
// // //   showADTab: boolean;

// // //   activeSubTab: "derma" | "ad";
// // // }

// // // const DermReportTab: React.FC<Props> = ({
// // //   emrId,
// // //   patientAge,
// // //   doctorName,
// // //   userId,
// // // }) => {
// // //   const { doctor } = useAuth();


// // //   const [loading, setLoading] = useState(false);
// // //   const [activeMainTab, setActiveMainTab] = useState<"derma" | "ad">("derma");

// // //   const [teleDiagnosis, setTeleDiagnosis] = useState("");
// // //   const [medicalAdvice, setMedicalAdvice] = useState("");

// // //   const [recommendations, setRecommendations] = useState({
// // //     none: false,
// // //     followAdvice: false,
// // //     consultDerm: false,
// // //   });

// // //   const [isReviewed, setIsReviewed] = useState(false);

// // //   /* AD extra */
// // //   const [atopicRisk, setAtopicRisk] = useState<"Yes" | "No" | "">("");
// // //   const [minorAnswers, setMinorAnswers] = useState<Record<string, string>>({});

// // //   /* ---------- RESET ---------- */
// // //   const handleReset = () => {
// // //     setTeleDiagnosis("");
// // //     setMedicalAdvice("");
// // //     setRecommendations({
// // //       none: false,
// // //       followAdvice: false,
// // //       consultDerm: false,
// // //     });
// // //     setAtopicRisk("");
// // //     setMinorAnswers({});
// // //     setIsReviewed(false);
// // //   };

// // //   /* ---------- SUBMIT ---------- */
// // //   const handleSubmit = async () => {
// // //     // ✅ Validation
// // //     if (!teleDiagnosis.trim() || !medicalAdvice.trim()) {
// // //       alert("Please enter Tele Diagnosis and Medical Advice");
// // //       return;
// // //     }

// // //     if (!isReviewed) {
// // //       alert("Please confirm review before submitting.");
// // //       return;
// // //     }

// // //     try {
// // //       setLoading(true);

// // //       const payload = {
// // //         emrId,
// // //         chartType: "primary",
// // //         age: patientAge,
// // //         doctorName,
// // //         reportWriting: {
// // //           teleDiagnosis,
// // //           medicalAdvice,
// // //           recommendations,
// // //         },
// // //         status: "SUBMITTED",
// // //         createdBy: userId,
// // //       };

// // //       const res = await api.dataCollectionApi.post(
// // //         "/teledocs/dermatology/report/submit",
// // //         payload,
// // //       );

// // //       if (res.data?.success) {
// // //         alert("Report Submitted Successfully");

// // //         handleReset();
// // //       }
// // //     } catch (error) {
// // //       console.error("Submit failed:", error);
// // //       alert("Failed to submit report");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   return (
// // //     <div className="report-writing-section">
// // //       {/* MAIN TABS */}
// // //       <div className="main-tabs-container">
       
// // //       </div>

// // //       <h3 className="summary-title">Report Writing</h3>

// // //       <div className="report-grid">
// // //         {/* ================= DERMA ================= */}
// // //         {activeMainTab === "derma" && (
// // //           <div className="report-inputs">
// // //             <label>Tele-Diagnosis</label>
// // //             <textarea
// // //               value={teleDiagnosis}
// // //               onChange={(e) => setTeleDiagnosis(e.target.value)}
// // //             />

// // //             <label>Medical Advice</label>
// // //             <textarea
// // //               value={medicalAdvice}
// // //               onChange={(e) => setMedicalAdvice(e.target.value)}
// // //             />

// // //             <label>Recommendations</label>
// // //             <div className="checkbox-group">
// // //               <label>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={recommendations.none}
// // //                   onChange={(e) =>
// // //                     setRecommendations({
// // //                       ...recommendations,
// // //                       none: e.target.checked,
// // //                     })
// // //                   }
// // //                 />
// // //                 No action required
// // //               </label>

// // //               <label>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={recommendations.followAdvice}
// // //                   onChange={(e) =>
// // //                     setRecommendations({
// // //                       ...recommendations,
// // //                       followAdvice: e.target.checked,
// // //                     })
// // //                   }
// // //                 />
// // //                 Follow Medical Advice
// // //               </label>

// // //               <label>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={recommendations.consultDerm}
// // //                   onChange={(e) =>
// // //                     setRecommendations({
// // //                       ...recommendations,
// // //                       consultDerm: e.target.checked,
// // //                     })
// // //                   }
// // //                 />
// // //                 Consult Clinical Dermatologist
// // //               </label>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {/* ================= AD ================= */}
// // //         {activeMainTab === "ad" && (
          
// // //           <div className="report-inputs ad-grid">
// // //             {/* LEFT SIDE */}
// // //             <div>
// // //               <h4>Major Symptoms</h4>
// // //               <ul>
                
// // //                 <li>
// // //                   Pruritus: <span className="yes-text">Yes</span>
// // //                 </li>
                
// // //                 <li>
// // //                   Chronic relapsing: <span className="yes-text">Yes</span>
// // //                 </li>
               
// // //                 <li>
// // //                   Typical morphology: <span className="yes-text">Yes</span>
// // //                 </li>
               
// // //                 <li>
// // //                   Family history: <span className="no-text">No</span>
// // //                 </li>
// // //               </ul>

// // //               <p>
// // //                 <strong>IgE Count:</strong> --
// // //               </p>
            
// // //               <li>
// // //                 Allergic Rhinitis Risk: <span className="no-text">No</span>
// // //               </li>
// // //             </div>

// // //             {/* MIDDLE */}
// // //             <div>
// // //               <h4>Minor Symptoms</h4>

// // //               {[
// // //                 "Erythema",
// // //                 "Pityriasis Alba",
// // //                 "Darkening around the eyelids",
// // //                 "Dennie-Morgan Folds",
// // //                 "Cheilitis",
// // //                 "Anterior Neck-Folds",
// // //                 "Ichthyosis",
// // //                 "Hyper linear palms",
// // //                 "Hand and Foot Eczema",
// // //                 "Nipple Eczema",
// // //               ].map((item) => (
// // //                 <div key={item} className="yes-no-row">
// // //                   <span>{item}</span>

// // //                   <label>
// // //                     <input
// // //                       type="radio"
// // //                       name={item}
// // //                       checked={minorAnswers[item] === "Yes"}
// // //                       onChange={() =>
// // //                         setMinorAnswers({ ...minorAnswers, [item]: "Yes" })
// // //                       }
// // //                     />
// // //                     Yes
// // //                   </label>

// // //                   <label>
// // //                     <input
// // //                       type="radio"
// // //                       name={item}
// // //                       checked={minorAnswers[item] === "No"}
// // //                       onChange={() =>
// // //                         setMinorAnswers({ ...minorAnswers, [item]: "No" })
// // //                       }
// // //                     />
// // //                     No
// // //                   </label>
// // //                 </div>
// // //               ))}
// // //             </div>

// // //             {/* RIGHT SIDE */}
// // //             <div>
// // //               <label>Atopic Dermatitis Risk</label>
// // //               <div>
// // //                 <label>
// // //                   <input
// // //                     type="radio"
// // //                     checked={atopicRisk === "Yes"}
// // //                     onChange={() => setAtopicRisk("Yes")}
// // //                   />
// // //                   Yes
// // //                 </label>

// // //                 <label>
// // //                   <input
// // //                     type="radio"
// // //                     checked={atopicRisk === "No"}
// // //                     onChange={() => setAtopicRisk("No")}
// // //                   />
// // //                   No
// // //                 </label>
// // //               </div>

// // //               <label>Tele-Diagnosis</label>
// // //               <textarea
// // //                 value={teleDiagnosis}
// // //                 onChange={(e) => setTeleDiagnosis(e.target.value)}
// // //               />

// // //               <label>Medical Advice</label>
// // //               <textarea
// // //                 value={medicalAdvice}
// // //                 onChange={(e) => setMedicalAdvice(e.target.value)}
// // //               />

// // //               <label>Recommendations</label>
// // //               <div className="checkbox-group">
// // //                 <label>
// // //                   <input
// // //                     type="checkbox"
// // //                     checked={recommendations.none}
// // //                     onChange={(e) =>
// // //                       setRecommendations({
// // //                         ...recommendations,
// // //                         none: e.target.checked,
// // //                       })
// // //                     }
// // //                   />
// // //                   No action required
// // //                 </label>

// // //                 <label>
// // //                   <input
// // //                     type="checkbox"
// // //                     checked={recommendations.followAdvice}
// // //                     onChange={(e) =>
// // //                       setRecommendations({
// // //                         ...recommendations,
// // //                         followAdvice: e.target.checked,
// // //                       })
// // //                     }
// // //                   />
// // //                   Follow Medical Advice
// // //                 </label>

// // //                 <label>
// // //                   <input
// // //                     type="checkbox"
// // //                     checked={recommendations.consultDerm}
// // //                     onChange={(e) =>
// // //                       setRecommendations({
// // //                         ...recommendations,
// // //                         consultDerm: e.target.checked,
// // //                       })
// // //                     }
// // //                   />
// // //                   Consult Clinical Dermatologist
// // //                 </label>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         )}
// // //       </div>

// // //       {/* FOOTER */}
// // //       <div className="derm-footer-actions">
// // //         {doctor && (
// // //           <label className="review-checkbox">
// // //             <input
// // //               type="checkbox"
// // //               checked={isReviewed}
// // //               onChange={(e) => setIsReviewed(e.target.checked)}
// // //             />
// // //             Reviewed by Dr. {doctor.name}
// // //           </label>
// // //         )}

// // //         <button
// // //           className="submit-report-btn"
// // //           onClick={handleSubmit}
// // //           disabled={loading}
// // //         >
// // //           {loading ? "Submitting..." : "Submit"}
// // //         </button>

// // //         <button className="save-draft-btn" onClick={handleReset}>
// // //           Reset
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };
// // // export default DermReportTab;





// // // src/components/dermatology/DermReportTab.tsx

// // import React, { useState } from "react";
// // import "../../css/DermReportSection.css";
// // import { useAuth } from "../../context/AuthContext";
// // import api from "../../api/axiosConfig";

// // interface Props {
// //   emrId: string;
// //   patientAge: number;
// //   doctorName: string;
// //   userId: string;

// //   showADTab: boolean;

// //   // 🔥 COMING FROM PARENT
// //   activeSubTab: "derma" | "ad";
// // }

// // const DermReportTab: React.FC<Props> = ({
// //   emrId,
// //   patientAge,
// //   doctorName,
// //   userId,
// //   activeSubTab,
// // }) => {
// //   const { doctor } = useAuth();

// //   const [loading, setLoading] = useState(false);

// //   const [teleDiagnosis, setTeleDiagnosis] =
// //     useState("");

// //   const [medicalAdvice, setMedicalAdvice] =
// //     useState("");

// //   const [recommendations, setRecommendations] =
// //     useState({
// //       none: false,
// //       followAdvice: false,
// //       consultDerm: false,
// //     });

// //   const [isReviewed, setIsReviewed] =
// //     useState(false);

// //   /* =========================
// //      AD EXTRA
// //   ========================= */

// //   const [atopicRisk, setAtopicRisk] =
// //     useState<"Yes" | "No" | "">("");

// //   const [minorAnswers, setMinorAnswers] =
// //     useState<Record<string, string>>({});

// //   /* =========================
// //      RESET
// //   ========================= */

// //   const handleReset = () => {
// //     setTeleDiagnosis("");
// //     setMedicalAdvice("");

// //     setRecommendations({
// //       none: false,
// //       followAdvice: false,
// //       consultDerm: false,
// //     });

// //     setAtopicRisk("");
// //     setMinorAnswers({});
// //     setIsReviewed(false);
// //   };

// //   /* =========================
// //      SUBMIT
// //   ========================= */

// //   const handleSubmit = async () => {
// //     if (
// //       !teleDiagnosis.trim() ||
// //       !medicalAdvice.trim()
// //     ) {
// //       alert(
// //         "Please enter Tele Diagnosis and Medical Advice",
// //       );
// //       return;
// //     }

// //     if (!isReviewed) {
// //       alert(
// //         "Please confirm review before submitting.",
// //       );
// //       return;
// //     }

// //     try {
// //       setLoading(true);

// //       const payload = {
// //         emrId,
// //         chartType: "primary",
// //         age: patientAge,
// //         doctorName,

// //         reportWriting: {
// //           teleDiagnosis,
// //           medicalAdvice,
// //           recommendations,
// //         },

// //         status: "SUBMITTED",
// //         createdBy: userId,
// //       };

// //       const endpoint =
// //         activeSubTab === "ad"
// //           ? "/teledocs/dermatology/ad-report/submit"
// //           : "/teledocs/dermatology/report/submit";

// //       const res =
// //         await api.dataCollectionApi.post(
// //           endpoint,
// //           payload,
// //         );

// //       if (res.data?.success) {
// //         alert("Report Submitted Successfully");

// //         handleReset();
// //       }
// //     } catch (error) {
// //       console.error("Submit failed:", error);

// //       alert("Failed to submit report");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="report-writing-section">

// //       <h3 className="summary-title">
// //         Report Writing
// //       </h3>

// //       <div className="report-grid">

// //         {/* =====================================
// //             DERMA REPORT
// //         ===================================== */}

// //         {activeSubTab === "derma" && (
// //           <div className="report-inputs">

// //             <label>Tele-Diagnosis</label>

// //             <textarea
// //               value={teleDiagnosis}
// //               onChange={(e) =>
// //                 setTeleDiagnosis(e.target.value)
// //               }
// //             />

// //             <label>Medical Advice</label>

// //             <textarea
// //               value={medicalAdvice}
// //               onChange={(e) =>
// //                 setMedicalAdvice(e.target.value)
// //               }
// //             />

// //             <label>Recommendations</label>

// //             <div className="checkbox-group">

// //               <label>
// //                 <input
// //                   type="checkbox"
// //                   checked={recommendations.none}
// //                   onChange={(e) =>
// //                     setRecommendations({
// //                       ...recommendations,
// //                       none: e.target.checked,
// //                     })
// //                   }
// //                 />

// //                 No action required
// //               </label>

// //               <label>
// //                 <input
// //                   type="checkbox"
// //                   checked={
// //                     recommendations.followAdvice
// //                   }
// //                   onChange={(e) =>
// //                     setRecommendations({
// //                       ...recommendations,
// //                       followAdvice:
// //                         e.target.checked,
// //                     })
// //                   }
// //                 />

// //                 Follow Medical Advice
// //               </label>

// //               <label>
// //                 <input
// //                   type="checkbox"
// //                   checked={
// //                     recommendations.consultDerm
// //                   }
// //                   onChange={(e) =>
// //                     setRecommendations({
// //                       ...recommendations,
// //                       consultDerm:
// //                         e.target.checked,
// //                     })
// //                   }
// //                 />

// //                 Consult Clinical Dermatologist
// //               </label>
// //             </div>
// //           </div>
// //         )}

// //         {/* =====================================
// //             AD REPORT
// //         ===================================== */}

// //         {activeSubTab === "ad" && (
// //           <div className="report-inputs ad-grid">

// //             {/* LEFT */}

// //             <div>
// //               <h4>Major Symptoms</h4>

// //               <ul>
// //                 <li>
// //                   Pruritus:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Chronic relapsing:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Typical morphology:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Family history:
// //                   <span className="no-text">
// //                     No
// //                   </span>
// //                 </li>
// //               </ul>

// //               <p>
// //                 <strong>IgE Count:</strong> --
// //               </p>

// //               <p>
// //                 <strong>
// //                   Allergic Rhinitis Risk:
// //                 </strong>{" "}
// //                 <span className="no-text">
// //                   No
// //                 </span>
// //               </p>
// //             </div>

// //             {/* CENTER */}

// //             <div>
// //               <h4>Minor Symptoms</h4>

// //               {[
// //                 "Erythema",
// //                 "Pityriasis Alba",
// //                 "Darkening around the eyelids",
// //                 "Dennie-Morgan Folds",
// //                 "Cheilitis",
// //                 "Anterior Neck-Folds",
// //                 "Ichthyosis",
// //                 "Hyper linear palms",
// //                 "Hand and Foot Eczema",
// //                 "Nipple Eczema",
// //               ].map((item) => (
// //                 <div
// //                   key={item}
// //                   className="yes-no-row"
// //                 >
// //                   <span>{item}</span>

// //                   <label>
// //                     <input
// //                       type="radio"
// //                       name={item}
// //                       checked={
// //                         minorAnswers[item] ===
// //                         "Yes"
// //                       }
// //                       onChange={() =>
// //                         setMinorAnswers({
// //                           ...minorAnswers,
// //                           [item]: "Yes",
// //                         })
// //                       }
// //                     />

// //                     Yes
// //                   </label>

// //                   <label>
// //                     <input
// //                       type="radio"
// //                       name={item}
// //                       checked={
// //                         minorAnswers[item] ===
// //                         "No"
// //                       }
// //                       onChange={() =>
// //                         setMinorAnswers({
// //                           ...minorAnswers,
// //                           [item]: "No",
// //                         })
// //                       }
// //                     />

// //                     No
// //                   </label>
// //                 </div>
// //               ))}
// //             </div>

// //             {/* RIGHT */}

// //             <div>

// //               <label>
// //                 Atopic Dermatitis Risk
// //               </label>

// //               <div>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     checked={atopicRisk === "Yes"}
// //                     onChange={() =>
// //                       setAtopicRisk("Yes")
// //                     }
// //                   />

// //                   Yes
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     checked={atopicRisk === "No"}
// //                     onChange={() =>
// //                       setAtopicRisk("No")
// //                     }
// //                   />

// //                   No
// //                 </label>
// //               </div>

// //               <label>Tele-Diagnosis</label>

// //               <textarea
// //                 value={teleDiagnosis}
// //                 onChange={(e) =>
// //                   setTeleDiagnosis(
// //                     e.target.value,
// //                   )
// //                 }
// //               />

// //               <label>Medical Advice</label>

// //               <textarea
// //                 value={medicalAdvice}
// //                 onChange={(e) =>
// //                   setMedicalAdvice(
// //                     e.target.value,
// //                   )
// //                 }
// //               />

// //               <label>Recommendations</label>

// //               <div className="checkbox-group">

// //                 <label>
// //                   <input
// //                     type="checkbox"
// //                     checked={recommendations.none}
// //                     onChange={(e) =>
// //                       setRecommendations({
// //                         ...recommendations,
// //                         none: e.target.checked,
// //                       })
// //                     }
// //                   />

// //                   No action required
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="checkbox"
// //                     checked={
// //                       recommendations.followAdvice
// //                     }
// //                     onChange={(e) =>
// //                       setRecommendations({
// //                         ...recommendations,
// //                         followAdvice:
// //                           e.target.checked,
// //                       })
// //                     }
// //                   />

// //                   Follow Medical Advice
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="checkbox"
// //                     checked={
// //                       recommendations.consultDerm
// //                     }
// //                     onChange={(e) =>
// //                       setRecommendations({
// //                         ...recommendations,
// //                         consultDerm:
// //                           e.target.checked,
// //                       })
// //                     }
// //                   />

// //                   Consult Clinical Dermatologist
// //                 </label>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       {/* =====================================
// //           FOOTER
// //       ===================================== */}

// //       <div className="derm-footer-actions">

// //         {doctor && (
// //           <label className="review-checkbox">

// //             <input
// //               type="checkbox"
// //               checked={isReviewed}
// //               onChange={(e) =>
// //                 setIsReviewed(
// //                   e.target.checked,
// //                 )
// //               }
// //             />

// //             Reviewed by Dr. {doctor.name}
// //           </label>
// //         )}

// //         <button
// //           className="submit-report-btn"
// //           onClick={handleSubmit}
// //           disabled={loading}
// //         >
// //           {loading
// //             ? "Submitting..."
// //             : "Submit"}
// //         </button>

// //         <button
// //           className="save-draft-btn"
// //           onClick={handleReset}
// //         >
// //           Reset
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DermReportTab;



// // import React, { useState } from "react";
// // import "../../css/DermReportSection.css";
// // import { useAuth } from "../../context/AuthContext";
// // import api from "../../api/axiosConfig";
// // import {
// //   useNavigate
// // } from "react-router-dom";
// // interface Props {
// //   emrId: string;
// //   patientAge: number;
// //   doctorName: string;
// //   userId: string;
// //   sessionId: string;
// //   showADTab: boolean;

// //   activeSubTab: "derma" | "ad";

// //   dermaSubmitted: boolean;

// //   setDermaSubmitted: React.Dispatch<
// //     React.SetStateAction<boolean>
// //   >;

// //   adSubmitted: boolean;

// //   setAdSubmitted: React.Dispatch<
// //     React.SetStateAction<boolean>
// //   >;
// // }

// // const DermReportTab: React.FC<Props> = ({
// //   emrId,
// //   patientAge,
// //   doctorName,
// //   userId,
// //   sessionId,

// //   showADTab,

// //   activeSubTab,

// //   dermaSubmitted,
// //   setDermaSubmitted,

// //   adSubmitted,
// //   setAdSubmitted,
// // }) => {
// //   const { doctor } = useAuth();
// //  const navigate = useNavigate();
// //   const [loading, setLoading] = useState(false);

// //   /* =====================================
// //      DERMA STATES
// //   ===================================== */

// //   const [dermaTeleDiagnosis, setDermaTeleDiagnosis] =
// //     useState("");

// //   const [dermaMedicalAdvice, setDermaMedicalAdvice] =
// //     useState("");

// //   const [dermaRecommendation, setDermaRecommendation] =
// //     useState("");

// //   /* =====================================
// //      AD STATES
// //   ===================================== */

// //   const [adTeleDiagnosis, setAdTeleDiagnosis] =
// //     useState("");

// //   const [adMedicalAdvice, setAdMedicalAdvice] =
// //     useState("");

// //   const [adRecommendation, setAdRecommendation] =
// //     useState("");

// //   /* =====================================
// //      COMMON STATES
// //   ===================================== */

// //   const [isReviewed, setIsReviewed] =
// //     useState(false);

// //   const [atopicRisk, setAtopicRisk] =
// //     useState<"Yes" | "No" | "">("");

// //   const [minorAnswers, setMinorAnswers] =
// //     useState<Record<string, string>>({});

// //   /* =====================================
// //      RESET
// //   ===================================== */

// //   const handleReset = () => {
// //     setDermaTeleDiagnosis("");
// //     setDermaMedicalAdvice("");
// //     setDermaRecommendation("");

// //     setAdTeleDiagnosis("");
// //     setAdMedicalAdvice("");
// //     setAdRecommendation("");

// //     setAtopicRisk("");
// //     setMinorAnswers({});
// //     setIsReviewed(false);
// //   };

// //   /* =====================================
// //      SUBMIT
// //   ===================================== */

// //   // const handleSubmit = async () => {
// //   //   try {
// //   //     const isAD = activeSubTab === "ad";

// //   //     const teleDiagnosis = isAD
// //   //       ? adTeleDiagnosis
// //   //       : dermaTeleDiagnosis;

// //   //     const medicalAdvice = isAD
// //   //       ? adMedicalAdvice
// //   //       : dermaMedicalAdvice;

// //   //     const recommendation = isAD
// //   //       ? adRecommendation
// //   //       : dermaRecommendation;

// //   //     if (
// //   //       !teleDiagnosis.trim() ||
// //   //       !medicalAdvice.trim()
// //   //     ) {
// //   //       alert(
// //   //         "Please enter Tele Diagnosis and Medical Advice",
// //   //       );
// //   //       return;
// //   //     }

// //   //     if (!recommendation) {
// //   //       alert("Please select recommendation");
// //   //       return;
// //   //     }

// //   //     if (!isReviewed) {
// //   //       alert(
// //   //         "Please confirm review before submitting.",
// //   //       );
// //   //       return;
// //   //     }

// //   //     setLoading(true);

// //   //     const payload = {
// //   //       emrId,
// //   //       chartType: "primary",
// //   //       age: patientAge,
// //   //       doctorName,

// //   //       reportWriting: {
// //   //         teleDiagnosis,
// //   //         medicalAdvice,
// //   //         recommendation,
// //   //       },

// //   //       status: "SUBMITTED",
// //   //       createdBy: userId,
// //   //     };

// //   //     const endpoint = isAD
// //   //       ? "/teledocs/dermatology/oral-cavity/report"
// //   //       : "/teledocs/dermatology/report/submit";

// //   //     console.log("SUBMIT PAYLOAD =", payload);

// //   //     const res =
// //   //       await api.dataCollectionApi.post(
// //   //         endpoint,
// //   //         payload,
// //   //       );

// //   //     console.log("SUBMIT RESPONSE =", res.data);

// //   //     alert("Report Submitted Successfully");

// //   //     handleReset();
// //   //   } catch (error) {
// //   //     console.error("Submit failed:", error);

// //   //     alert("Failed to submit report");
// //   //   } finally {
// //   //     setLoading(false);
// //   //   }
// //   // };

// // // const completeWorkflow = async () => {
// // //   try {

// // //     const response = await fetch(
// // //       `http://localhost:4008/sessions/${sessionId}/tele-reporting/dermatologist/submit`,
// // //       {
// // //         method: "POST",

// // //         headers: {
// // //           "Content-Type": "application/json",
// // //         },
// // //       }
// // //     );

// // //     const data = await response.json();

// // //     console.log(
// // //       "WORKFLOW RESPONSE =",
// // //       data
// // //     );

// // //     /* API FAILED */

// // //     if (!response.ok) {

// // //       alert(
// // //         "Workflow API failed"
// // //       );

// // //       return;
// // //     }

// // //     /* SUCCESS */

// // //     alert(
// // //       "All reports completed successfully"
// // //     );

// // //     handleReset();

// // //     // navigate("/queue/dermatology");
// // // // window.location.href = "/queue/dermatology";
// // // navigate("/queue/dermatology");

// // // window.location.reload();
// // // } catch (error) {

// // //     console.error(
// // //       "WORKFLOW ERROR =",
// // //       error
// // //     );

// // //     alert(
// // //       "Workflow completion failed"
// // //     );
// // //   }
// // // };

// // const completeWorkflow = async () => {
// //   try {

// //     console.log(
// //       "COMPLETING WORKFLOW =",
// //       sessionId
// //     );

// //     const response =
// //       await api.CenterworkflowApi.post(
// //         `/sessions/${sessionId}/tele-reporting/dermatologist/submit`
// //       );

// //     console.log(
// //       "WORKFLOW RESPONSE =",
// //       response.data
// //     );

// //     alert(
// //       "All reports completed successfully"
// //     );

// //     handleReset();

// //     navigate("/queue/dermatology");

// //     window.location.reload();

// //   } catch (error) {

// //     console.error(
// //       "WORKFLOW ERROR =",
// //       error
// //     );

// //     alert(
// //       "Workflow completion failed"
// //     );
// //   }
// // };

// //   const handleSubmit = async () => {
// //   try {
// //     const isAD = activeSubTab === "ad";

// //     /* =====================================
// //        COMMON VALIDATIONS
// //     ===================================== */

// //     const teleDiagnosis = isAD
// //       ? adTeleDiagnosis
// //       : dermaTeleDiagnosis;

// //     const medicalAdvice = isAD
// //       ? adMedicalAdvice
// //       : dermaMedicalAdvice;

// //     const recommendation = isAD
// //       ? adRecommendation
// //       : dermaRecommendation;

// //     if (
// //       !teleDiagnosis.trim() ||
// //       !medicalAdvice.trim()
// //     ) {
// //       alert(
// //         "Please enter Tele Diagnosis and Medical Advice",
// //       );
// //       return;
// //     }

// //     if (!recommendation) {
// //       alert("Please select recommendation");
// //       return;
// //     }

// //     if (!isReviewed) {
// //       alert(
// //         "Please confirm review before submitting.",
// //       );
// //       return;
// //     }

// //     setLoading(true);

// //     /* =====================================
// //        AD PAYLOAD
// //     ===================================== */

// //     if (isAD) {
// //       // const adPayload = {
// //       //   emrId,
// //       //   chartType: "primary",

// //       //   majorSymptoms: {
// //       //     pruritus: true,
// //       //     chronicRelapsing: true,
// //       //     typicalMorphology: true,
// //       //     familyHistory: false,
// //       //     igeCount: "--",
// //       //     allergicRhinitisRisk: false,
// //       //   },

// //       //   minorSymptoms: {
// //       //     erythema:
// //       //       minorAnswers["Erythema"] === "Yes",

// //       //     pityriasisAlba:
// //       //       minorAnswers[
// //       //         "Pityriasis Alba"
// //       //       ] === "Yes",

// //       //     darkeningAroundEyelids:
// //       //       minorAnswers[
// //       //         "Darkening around the eyelids"
// //       //       ] === "Yes",

// //       //     dennieMorganFolds:
// //       //       minorAnswers[
// //       //         "Dennie-Morgan Folds"
// //       //       ] === "Yes",

// //       //     cheilitis:
// //       //       minorAnswers["Cheilitis"] ===
// //       //       "Yes",

// //       //     anteriorNeckFolds:
// //       //       minorAnswers[
// //       //         "Anterior Neck-Folds"
// //       //       ] === "Yes",

// //       //     ichthyosis:
// //       //       minorAnswers["Ichthyosis"] ===
// //       //       "Yes",

// //       //     hyperLinearPalms:
// //       //       minorAnswers[
// //       //         "Hyper linear palms"
// //       //       ] === "Yes",

// //       //     handAndFootEczema:
// //       //       minorAnswers[
// //       //         "Hand and Foot Eczema"
// //       //       ] === "Yes",

// //       //     nippleEczema:
// //       //       minorAnswers[
// //       //         "Nipple Eczema"
// //       //       ] === "Yes",
// //       //   },

// //       //   atopicDermatitisRisk:
// //       //     atopicRisk === "Yes",

// //       //   teleDiagnosis: adTeleDiagnosis,

// //       //   medicalAdvice: adMedicalAdvice,

// //       //   recommendations: {
// //       //     noActionRequired:
// //       //       adRecommendation === "none",

// //       //     followMedicalAdvice:
// //       //       adRecommendation ===
// //       //       "followAdvice",

// //       //     consultClinicalDermatologist:
// //       //       adRecommendation ===
// //       //       "consultDerm",
// //       //   },

// //       //   reviewedBy: doctor?.name || "",
// //       // };



// //       const adPayload = {
// //   emrId,
// //   chartType: "primary",

// //   majorSymptoms: {
// //     pruritus: true,
// //     chronicRelapsing: true,
// //     typicalMorphology: true,
// //     familyHistory: false,
// //     igeCount: "--",
// //     allergicRhinitisRisk: false,
// //   },

// //   minorSymptoms: {
// //     erythema:
// //       minorAnswers["Erythema"] === "Yes",

// //     pityriasisAlba:
// //       minorAnswers["Pityriasis Alba"] === "Yes",

// //     darkeningAroundEyelids:
// //       minorAnswers[
// //         "Darkening around the eyelids"
// //       ] === "Yes",

// //     dennieMorganFolds:
// //       minorAnswers[
// //         "Dennie-Morgan Folds"
// //       ] === "Yes",

// //     cheilitis:
// //       minorAnswers["Cheilitis"] === "Yes",

// //     anteriorNeckFolds:
// //       minorAnswers[
// //         "Anterior Neck-Folds"
// //       ] === "Yes",

// //     ichthyosis:
// //       minorAnswers["Ichthyosis"] === "Yes",

// //     hyperLinearPalms:
// //       minorAnswers[
// //         "Hyper linear palms"
// //       ] === "Yes",

// //     handAndFootEczema:
// //       minorAnswers[
// //         "Hand and Foot Eczema"
// //       ] === "Yes",

// //     nippleEczema:
// //       minorAnswers[
// //         "Nipple Eczema"
// //       ] === "Yes",
// //   },

// //   atopicDermatitisRisk:
// //     atopicRisk === "Yes",

// //   teleDiagnosis: adTeleDiagnosis,

// //   medicalAdvice: adMedicalAdvice,

// //   recommendations: {
// //     noActionRequired:
// //       adRecommendation === "none",

// //     followMedicalAdvice:
// //       adRecommendation === "followAdvice",

// //     consultClinicalDermatologist:
// //       adRecommendation === "consultDerm",
// //   },

// // reviewedByDoctor: {
// //   reviewed: isReviewed,
// //   doctorName: doctor?.name || "",
// // },
// // };

// //       console.log(
// //         "AD PAYLOAD =",
// //         adPayload,
// //       );

// //       const res =
// //         await api.dataCollectionApi.post(
// //           "/api/teledocs/ad-symptoms",
// //           adPayload,
// //         );

// //       console.log(
// //         "AD RESPONSE =",
// //         res.data,
// //       );
// //     }

// //     /* =====================================
// //        DERMA PAYLOAD
// //     ===================================== */

// //     else {
// //       const dermaPayload = {
// //         emrId,
// //         chartType: "primary",
// //         age: String(patientAge),
// //         doctorName,

// //         reportWriting: {
// //           teleDiagnosis:
// //             dermaTeleDiagnosis,

// //           medicalAdvice:
// //             dermaMedicalAdvice,

// //           recommendation:
// //             dermaRecommendation,
// //         },

// //         status: "SUBMITTED",
// //         createdBy: userId,
// //       };

// //       console.log(
// //         "DERMA PAYLOAD =",
// //         dermaPayload,
// //       );

// //       const res =
// //         await api.dataCollectionApi.post(
// //           "/teledocs/dermatology/hair/report",
// //           dermaPayload,
// //         );

// //     //   console.log(
// //     //     "DERMA RESPONSE =",
// //     //     res.data,
// //     //   );
// //     // }

// //     // alert("Report Submitted Successfully");

// //     // handleReset();



// //     console.log(
// //   "DERMA RESPONSE =",
// //   res.data,
// // );
// // }

// // /* =====================================
// //    SUBMISSION TRACKING
// // ===================================== */

// // // if (activeSubTab === "derma") {

// // //   setDermaSubmitted(true);

// // //   /* AD NOT REQUIRED */

// // //   if (!showADTab) {

// // //     alert("Derma report submitted successfully");

// // //     handleReset();

// // //     navigate("/queue/dermatology");

// // //     return;
// // //   }

// // //   /* AD ALREADY SUBMITTED */

// // //   if (adSubmitted) {

// // //     alert("All reports submitted successfully");

// // //     handleReset();

// // //     navigate("/queue/dermatology");

// // //     return;
// // //   }

// // //   /* WAIT FOR AD */

// // //   alert(
// // //     "Derma report saved. Please complete AD report."
// // //   );
// // // }

// // // if (activeSubTab === "ad") {

// // //   setAdSubmitted(true);

// // //   /* DERMA ALREADY SUBMITTED */

// // //   if (dermaSubmitted) {

// // //     alert("All reports submitted successfully");

// // //     handleReset();

// // //     navigate("/queue/dermatology");

// // //     return;
// // //   }

// // //   /* WAIT FOR DERMA */

// // //   alert(
// // //     "AD report saved. Please complete Derma report."
// // //   );
// // // }



// // /* =====================================
// //    SUBMISSION TRACKING
// // ===================================== */

// // if (activeSubTab === "derma") {

// //   setDermaSubmitted(true);

// //   /* AD REQUIRED */

// //   if (showADTab && !adSubmitted) {

// //     alert(
// //       "Derma report saved. Please complete AD report."
// //     );

// //     return;
// //   }

// //   /* COMPLETE WORKFLOW */

// //   await completeWorkflow();
// // }

// // if (activeSubTab === "ad") {

// //   setAdSubmitted(true);

// //   /* WAIT FOR DERMA */

// //   if (!dermaSubmitted) {

// //     alert(
// //       "AD report saved. Please complete Derma report."
// //     );

// //     return;
// //   }

// //   /* COMPLETE WORKFLOW */

// //   await completeWorkflow();
// // }


// //   } catch (error: any) {
// //   console.log(
// //     "ERROR RESPONSE =",
// //     error?.response?.data
// //   );

// //   console.error("Submit failed:", error);

// //   alert("Failed to submit report");
// // } finally {
// //     setLoading(false);
// //   }
// // };

// //   return (
// //     <div className="report-writing-section">

// //       <h3 className="summary-title">
// //         Report Writing
// //       </h3>

// //       <div className="report-grid">

// //         {/* =====================================
// //             DERMA REPORT
// //         ===================================== */}

// //         {activeSubTab === "derma" && (
// //           <div className="report-inputs">

// //             <label>Tele-Diagnosis</label>

// //             <textarea
// //               value={dermaTeleDiagnosis}
// //               onChange={(e) =>
// //                 setDermaTeleDiagnosis(
// //                   e.target.value,
// //                 )
// //               }
// //             />

// //             <label>Medical Advice</label>

// //             <textarea
// //               value={dermaMedicalAdvice}
// //               onChange={(e) =>
// //                 setDermaMedicalAdvice(
// //                   e.target.value,
// //                 )
// //               }
// //             />

// //             <label>Recommendations</label>

// //             <div className="checkbox-group">

// //               <label>
// //                 <input
// //                   type="radio"
// //                   name="dermaRecommendation"
// //                   checked={
// //                     dermaRecommendation ===
// //                     "none"
// //                   }
// //                   onChange={() =>
// //                     setDermaRecommendation(
// //                       "none",
// //                     )
// //                   }
// //                 />

// //                 No action required
// //               </label>

// //               <label>
// //                 <input
// //                   type="radio"
// //                   name="dermaRecommendation"
// //                   checked={
// //                     dermaRecommendation ===
// //                     "followAdvice"
// //                   }
// //                   onChange={() =>
// //                     setDermaRecommendation(
// //                       "followAdvice",
// //                     )
// //                   }
// //                 />

// //                 Follow Medical Advice
// //               </label>

// //               <label>
// //                 <input
// //                   type="radio"
// //                   name="dermaRecommendation"
// //                   checked={
// //                     dermaRecommendation ===
// //                     "consultDerm"
// //                   }
// //                   onChange={() =>
// //                     setDermaRecommendation(
// //                       "consultDerm",
// //                     )
// //                   }
// //                 />

// //                 Consult Clinical Dermatologist
// //               </label>
// //             </div>
// //           </div>
// //         )}

// //         {/* =====================================
// //             AD REPORT
// //         ===================================== */}

// //         {activeSubTab === "ad" && (
// //           <div className="report-inputs ad-grid">

// //             {/* LEFT */}

// //             <div>
// //               <h4>Major Symptoms</h4>

// //               <ul>
// //                 <li>
// //                   Pruritus:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Chronic relapsing:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Typical morphology:
// //                   <span className="yes-text">
// //                     Yes
// //                   </span>
// //                 </li>

// //                 <li>
// //                   Family history:
// //                   <span className="no-text">
// //                     No
// //                   </span>
// //                 </li>
// //               </ul>

// //               <p>
// //                 <strong>IgE Count:</strong> --
// //               </p>

// //               <p>
// //                 <strong>
// //                   Allergic Rhinitis Risk:
// //                 </strong>{" "}
// //                 <span className="no-text">
// //                   No
// //                 </span>
// //               </p>
// //             </div>

// //             {/* CENTER */}

// //             <div>
// //               <h4>Minor Symptoms</h4>

// //               {[
// //                 "Erythema",
// //                 "Pityriasis Alba",
// //                 "Darkening around the eyelids",
// //                 "Dennie-Morgan Folds",
// //                 "Cheilitis",
// //                 "Anterior Neck-Folds",
// //                 "Ichthyosis",
// //                 "Hyper linear palms",
// //                 "Hand and Foot Eczema",
// //                 "Nipple Eczema",
// //               ].map((item) => (
// //                 <div
// //                   key={item}
// //                   className="yes-no-row"
// //                 >
// //                   <span>{item}</span>

// //                   <label>
// //                     <input
// //                       type="radio"
// //                       name={item}
// //                       checked={
// //                         minorAnswers[item] ===
// //                         "Yes"
// //                       }
// //                       onChange={() =>
// //                         setMinorAnswers({
// //                           ...minorAnswers,
// //                           [item]: "Yes",
// //                         })
// //                       }
// //                     />

// //                     Yes
// //                   </label>

// //                   <label>
// //                     <input
// //                       type="radio"
// //                       name={item}
// //                       checked={
// //                         minorAnswers[item] ===
// //                         "No"
// //                       }
// //                       onChange={() =>
// //                         setMinorAnswers({
// //                           ...minorAnswers,
// //                           [item]: "No",
// //                         })
// //                       }
// //                     />

// //                     No
// //                   </label>
// //                 </div>
// //               ))}
// //             </div>

// //             {/* RIGHT */}

// //             <div>

// //               <label>
// //                 Atopic Dermatitis Risk
// //               </label>

// //               <div>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     checked={
// //                       atopicRisk === "Yes"
// //                     }
// //                     onChange={() =>
// //                       setAtopicRisk("Yes")
// //                     }
// //                   />

// //                   Yes
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     checked={
// //                       atopicRisk === "No"
// //                     }
// //                     onChange={() =>
// //                       setAtopicRisk("No")
// //                     }
// //                   />

// //                   No
// //                 </label>
// //               </div>

// //               <label>Tele-Diagnosis</label>

// //               <textarea
// //                 value={adTeleDiagnosis}
// //                 onChange={(e) =>
// //                   setAdTeleDiagnosis(
// //                     e.target.value,
// //                   )
// //                 }
// //               />

// //               <label>Medical Advice</label>

// //               <textarea
// //                 value={adMedicalAdvice}
// //                 onChange={(e) =>
// //                   setAdMedicalAdvice(
// //                     e.target.value,
// //                   )
// //                 }
// //               />

// //               <label>Recommendations</label>

// //               <div className="checkbox-group">

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     name="adRecommendation"
// //                     checked={
// //                       adRecommendation ===
// //                       "none"
// //                     }
// //                     onChange={() =>
// //                       setAdRecommendation(
// //                         "none",
// //                       )
// //                     }
// //                   />

// //                   No action required
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     name="adRecommendation"
// //                     checked={
// //                       adRecommendation ===
// //                       "followAdvice"
// //                     }
// //                     onChange={() =>
// //                       setAdRecommendation(
// //                         "followAdvice",
// //                       )
// //                     }
// //                   />

// //                   Follow Medical Advice
// //                 </label>

// //                 <label>
// //                   <input
// //                     type="radio"
// //                     name="adRecommendation"
// //                     checked={
// //                       adRecommendation ===
// //                       "consultDerm"
// //                     }
// //                     onChange={() =>
// //                       setAdRecommendation(
// //                         "consultDerm",
// //                       )
// //                     }
// //                   />

// //                   Consult Clinical Dermatologist
// //                 </label>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       {/* =====================================
// //           FOOTER
// //       ===================================== */}

// //       <div className="derm-footer-actions">

// //         {doctor && (
// //           <label className="review-checkbox">

// //             <input
// //               type="checkbox"
// //               checked={isReviewed}
// //               onChange={(e) =>
// //                 setIsReviewed(
// //                   e.target.checked,
// //                 )
// //               }
// //             />

// //             Reviewed by Dr. {doctor.name}
// //           </label>
// //         )}

// //         <button
// //           className="submit-report-btn"
// //           onClick={handleSubmit}
// //           disabled={loading}
// //         >
// //           {loading
// //             ? "Submitting..."
// //             : "Submit"}
// //         </button>

// //         <button
// //           className="save-draft-btn"
// //           onClick={handleReset}
// //         >
// //           Reset
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DermReportTab;






// import React, { useState, useEffect } from "react";
// import "../../css/DermReportSection.css";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../api/axiosConfig";
// import { useNavigate } from "react-router-dom";

// interface Props {
//   emrId: string;
//   patientAge: number;
//   doctorName: string;
//   userId: string;
//   sessionId: string;
//   showADTab: boolean;
//   activeSubTab: "derma" | "ad";
//   dermaSubmitted: boolean;
//   setDermaSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
//   adSubmitted: boolean;
//   setAdSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
// }

// const DermReportTab: React.FC<Props> = ({
//   emrId,
//   patientAge,
//   doctorName,
//   userId,
//   sessionId,
//   showADTab,
//   activeSubTab,
//   dermaSubmitted,
//   setDermaSubmitted,
//   adSubmitted,
//   setAdSubmitted,
// }) => {
//   const { doctor } = useAuth();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   /* =====================================
//      DERMA STATES
//   ===================================== */
//   const [dermaTeleDiagnosis, setDermaTeleDiagnosis] = useState("");
//   const [dermaMedicalAdvice, setDermaMedicalAdvice] = useState("");
//   const [dermaRecommendation, setDermaRecommendation] = useState("");

//   /* =====================================
//      AD STATES (MANUAL INPUTS)
//   ===================================== */
//   const [adTeleDiagnosis, setAdTeleDiagnosis] = useState("");
//   const [adMedicalAdvice, setAdMedicalAdvice] = useState("");
//   const [adRecommendation, setAdRecommendation] = useState("");

//   /* =====================================
//      COMMON / DB-DRIVEN STATES
//   ===================================== */
//   const [isReviewed, setIsReviewed] = useState(false);
//   const [atopicRisk, setAtopicRisk] = useState<"Yes" | "No" | "">("");
//   const [minorAnswers, setMinorAnswers] = useState<Record<string, string>>({});

//   // Fetched Major Symptoms
//   const [hasPruritus, setHasPruritus] = useState<boolean | null>(null);
//   const [hasChronicRelapsing, setHasChronicRelapsing] = useState<boolean | null>(null);
//   const [hasTypicalMorphology, setHasTypicalMorphology] = useState<boolean | null>(null);
//   const [hasFamilyHistory, setHasFamilyHistory] = useState<boolean | null>(null);
//   const [igeCount, setIgeCount] = useState<number | null>(null);

//   /* =====================================
//      FETCHING DB DATA ON MOUNT
//   ===================================== */

//   // 1. Fetch Major Symptoms (Health Scores)
//   useEffect(() => {
//     if (!emrId || activeSubTab !== "ad") return;

//     const fetchHealthData = async () => {
//       try {
//         const res = await api.Questionnair.get(
//           `/api/scoring/scoresId/${emrId}/health`
//         );
//         const results = res?.data?.scores?.resultsById || {};
//         const adAnswer = String(results["1220"] || "").toLowerCase();

//         setHasChronicRelapsing(adAnswer === "yes" || adAnswer === "maybe");
//         setHasPruritus(adAnswer === "yes" || adAnswer === "maybe");
//         setHasTypicalMorphology(adAnswer === "yes" || adAnswer === "maybe");
//         setHasFamilyHistory(adAnswer === "yes" || adAnswer === "maybe");
//       } catch (err) {
//         console.error("Failed to fetch major symptoms", err);
//       }
//     };
//     fetchHealthData();
//   }, [emrId, activeSubTab]);

//   // 2. Fetch Minor Symptoms
//   useEffect(() => {
//     if (!emrId || activeSubTab !== "ad") return;

//     const fetchMinorSymptoms = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/atopic-dermatitis/${emrId}`
//         );

//         const features = response?.data?.data?.features || [];
//         const newAnswers: Record<string, string> = {};

//         // Map backend codes to the exact frontend labels used in the array below
//         const keyMapping: Record<string, string> = {
//           "facial_pallor": "Erythema",
//           "pityriasis_alba": "Pityriasis Alba",
//           "darkening_around_the_eyelids": "Darkening around the eyelids",
//           "infra_orbital_folds": "Dennie-Morgan Folds",
//           "dry_lips": "Cheilitis",
//           "anterior_neck_folds": "Anterior Neck-Folds",
//           "ichthyosis": "Ichthyosis",
//           "increased_palmar_lines": "Hyper linear palms",
//           "hand_and_foot_eczema": "Hand and Foot Eczema",
//           "nipple_eczema": "Nipple Eczema",
//         };

//         features.forEach((feature: any) => {
//           const label = keyMapping[feature.code];
//           if (label) {
//             newAnswers[label] = feature.observed === true ? "Yes" : "No";
//           }
//         });

//         setMinorAnswers(newAnswers);
//       } catch (error) {
//         console.error("Failed to fetch minor symptoms", error);
//       }
//     };
//     fetchMinorSymptoms();
//   }, [emrId, activeSubTab]);

//   // 3. Fetch IgE Count
//   useEffect(() => {
//     if (!emrId || activeSubTab !== "ad") return;

//     const fetchIgeCount = async () => {
//       try {
//         const response = await api.dataCollectionApi.get(
//           `/api/forms/lab-report/${emrId}`
//         );
//         const igeValue =
//           response?.data?.data?.["Immunoglobulin E (Total IgE)"]?.["Immunoglobulin E"] ?? null;
//         setIgeCount(igeValue);
//       } catch (error) {
//         console.error("Failed to fetch IgE count", error);
//       }
//     };
//     fetchIgeCount();
//   }, [emrId, activeSubTab]);

//   /* =====================================
//      RESET
//   ===================================== */
//   const handleReset = () => {
//     setDermaTeleDiagnosis("");
//     setDermaMedicalAdvice("");
//     setDermaRecommendation("");

//     setAdTeleDiagnosis("");
//     setAdMedicalAdvice("");
//     setAdRecommendation("");

//     setAtopicRisk("");
//     setMinorAnswers({});
//     setIsReviewed(false);
//   };

//   /* =====================================
//      WORKFLOW
//   ===================================== */
//   const completeWorkflow = async () => {
//     try {
//       console.log("COMPLETING WORKFLOW =", sessionId);

//       const response = await api.CenterworkflowApi.post(
//         `/sessions/${sessionId}/tele-reporting/dermatologist/submit`
//       );

//       console.log("WORKFLOW RESPONSE =", response.data);
//       alert("All reports completed successfully");
//       handleReset();
//       navigate("/queue/dermatology");
//       window.location.reload();
//     } catch (error) {
//       console.error("WORKFLOW ERROR =", error);
//       alert("Workflow completion failed");
//     }
//   };

//   /* =====================================
//      SUBMIT
//   ===================================== */
//   const handleSubmit = async () => {
//     try {
//       const isAD = activeSubTab === "ad";

//       /* COMMON VALIDATIONS */
//       const teleDiagnosis = isAD ? adTeleDiagnosis : dermaTeleDiagnosis;
//       const medicalAdvice = isAD ? adMedicalAdvice : dermaMedicalAdvice;
//       const recommendation = isAD ? adRecommendation : dermaRecommendation;

//       if (!teleDiagnosis.trim() || !medicalAdvice.trim()) {
//         alert("Please enter Tele Diagnosis and Medical Advice");
//         return;
//       }

//       if (!recommendation) {
//         alert("Please select recommendation");
//         return;
//       }

//       if (!isReviewed) {
//         alert("Please confirm review before submitting.");
//         return;
//       }

//       setLoading(true);

//       /* =====================================
//          AD PAYLOAD
//       ===================================== */
//       if (isAD) {
//         const adPayload = {
//           emrId,
//           chartType: "primary",
//           // 🔥 NOW USING DYNAMIC STATE DATA INSTEAD OF HARDCODED BOOLEANS
//           majorSymptoms: {
//             pruritus: !!hasPruritus,
//             chronicRelapsing: !!hasChronicRelapsing,
//             typicalMorphology: !!hasTypicalMorphology,
//             familyHistory: !!hasFamilyHistory,
//             igeCount: igeCount !== null ? String(igeCount) : "--",
//             allergicRhinitisRisk: !!hasPruritus, 
//           },
//           minorSymptoms: {
//             erythema: minorAnswers["Erythema"] === "Yes",
//             pityriasisAlba: minorAnswers["Pityriasis Alba"] === "Yes",
//             darkeningAroundEyelids: minorAnswers["Darkening around the eyelids"] === "Yes",
//             dennieMorganFolds: minorAnswers["Dennie-Morgan Folds"] === "Yes",
//             cheilitis: minorAnswers["Cheilitis"] === "Yes",
//             anteriorNeckFolds: minorAnswers["Anterior Neck-Folds"] === "Yes",
//             ichthyosis: minorAnswers["Ichthyosis"] === "Yes",
//             hyperLinearPalms: minorAnswers["Hyper linear palms"] === "Yes",
//             handAndFootEczema: minorAnswers["Hand and Foot Eczema"] === "Yes",
//             nippleEczema: minorAnswers["Nipple Eczema"] === "Yes",
//           },
//           atopicDermatitisRisk: atopicRisk === "Yes",
//           teleDiagnosis: adTeleDiagnosis,
//           medicalAdvice: adMedicalAdvice,
//           recommendations: {
//             noActionRequired: adRecommendation === "none",
//             followMedicalAdvice: adRecommendation === "followAdvice",
//             consultClinicalDermatologist: adRecommendation === "consultDerm",
//           },
//           reviewedByDoctor: {
//             reviewed: isReviewed,
//             doctorName: doctor?.name || "",
//           },
//         };

//         console.log("AD PAYLOAD =", adPayload);
//         const res = await api.dataCollectionApi.post(
//           "/api/teledocs/ad-symptoms",
//           adPayload
//         );
//         console.log("AD RESPONSE =", res.data);
//       }
//       /* =====================================
//          DERMA PAYLOAD
//       ===================================== */
//       else {
//         const dermaPayload = {
//           emrId,
//           chartType: "primary",
//           age: String(patientAge),
//           doctorName,
//           reportWriting: {
//             teleDiagnosis: dermaTeleDiagnosis,
//             medicalAdvice: dermaMedicalAdvice,
//             recommendation: dermaRecommendation,
//           },
//           status: "SUBMITTED",
//           createdBy: userId,
//         };

//         console.log("DERMA PAYLOAD =", dermaPayload);
//         const res = await api.dataCollectionApi.post(
//           "/teledocs/dermatology/hair/report",
//           dermaPayload
//         );
//         console.log("DERMA RESPONSE =", res.data);
//       }

//       /* =====================================
//          SUBMISSION TRACKING
//       ===================================== */
//       if (activeSubTab === "derma") {
//         setDermaSubmitted(true);
//         if (showADTab && !adSubmitted) {
//           alert("Derma report saved. Please complete AD report.");
//           return;
//         }
//         await completeWorkflow();
//       }

//       if (activeSubTab === "ad") {
//         setAdSubmitted(true);
//         if (!dermaSubmitted) {
//           alert("AD report saved. Please complete Derma report.");
//           return;
//         }
//         await completeWorkflow();
//       }
//     } catch (error: any) {
//       console.log("ERROR RESPONSE =", error?.response?.data);
//       console.error("Submit failed:", error);
//       alert("Failed to submit report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getYesNoClass = (val: boolean | null) => {
//     if (val === true) return "yes-text";
//     if (val === false) return "no-text";
//     return "";
//   };

//   return (
//     <div className="report-writing-section">
//       <h3 className="summary-title">Report Writing</h3>

//       <div className="report-grid">
//         {/* =====================================
//             DERMA REPORT UI
//         ===================================== */}
//         {activeSubTab === "derma" && (
//           <div className="report-inputs">
//             <label>Tele-Diagnosis</label>
//             <textarea
//               value={dermaTeleDiagnosis}
//               onChange={(e) => setDermaTeleDiagnosis(e.target.value)}
//             />

//             <label>Medical Advice</label>
//             <textarea
//               value={dermaMedicalAdvice}
//               onChange={(e) => setDermaMedicalAdvice(e.target.value)}
//             />

//             <label>Recommendations</label>
//             <div className="checkbox-group">
//               <label>
//                 <input
//                   type="radio"
//                   name="dermaRecommendation"
//                   checked={dermaRecommendation === "none"}
//                   onChange={() => setDermaRecommendation("none")}
//                 />
//                 No action required
//               </label>

//               <label>
//                 <input
//                   type="radio"
//                   name="dermaRecommendation"
//                   checked={dermaRecommendation === "followAdvice"}
//                   onChange={() => setDermaRecommendation("followAdvice")}
//                 />
//                 Follow Medical Advice
//               </label>

//               <label>
//                 <input
//                   type="radio"
//                   name="dermaRecommendation"
//                   checked={dermaRecommendation === "consultDerm"}
//                   onChange={() => setDermaRecommendation("consultDerm")}
//                 />
//                 Consult Clinical Dermatologist
//               </label>
//             </div>
//           </div>
//         )}

//         {/* =====================================
//             AD REPORT UI
//         ===================================== */}
//         {activeSubTab === "ad" && (
//           <div className="report-inputs ad-grid">
//             {/* LEFT */}
//             <div>
//               <h4>Major Symptoms</h4>
//               <ul>
//                 <li>
//                   Pruritus:{" "}
//                   <span className={getYesNoClass(hasPruritus)}>
//                     {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                   </span>
//                 </li>
//                 <li>
//                   Chronic relapsing:{" "}
//                   <span className={getYesNoClass(hasChronicRelapsing)}>
//                     {hasChronicRelapsing === null ? "--" : hasChronicRelapsing ? "Yes" : "No"}
//                   </span>
//                 </li>
//                 <li>
//                   Typical morphology:{" "}
//                   <span className={getYesNoClass(hasTypicalMorphology)}>
//                     {hasTypicalMorphology === null ? "--" : hasTypicalMorphology ? "Yes" : "No"}
//                   </span>
//                 </li>
//                 <li>
//                   Family history:{" "}
//                   <span className={getYesNoClass(hasFamilyHistory)}>
//                     {hasFamilyHistory === null ? "--" : hasFamilyHistory ? "Yes" : "No"}
//                   </span>
//                 </li>
//               </ul>

//               <p>
//                 <strong>IgE Count:</strong> {igeCount !== null ? igeCount : "--"}
//               </p>
//               <p>
//                 <strong>Allergic Rhinitis Risk:</strong>{" "}
//                 <span className={getYesNoClass(hasPruritus)}>
//                   {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
//                 </span>
//               </p>
//             </div>

//             {/* CENTER */}
//             <div>
//               <h4>Minor Symptoms</h4>
//               {[
//                 "Erythema",
//                 "Pityriasis Alba",
//                 "Darkening around the eyelids",
//                 "Dennie-Morgan Folds",
//                 "Cheilitis",
//                 "Anterior Neck-Folds",
//                 "Ichthyosis",
//                 "Hyper linear palms",
//                 "Hand and Foot Eczema",
//                 "Nipple Eczema",
//               ].map((item) => (
//                 <div key={item} className="yes-no-row">
//                   <span>{item}</span>
//                   <label>
//                     <input
//                       type="radio"
//                       name={item}
//                       checked={minorAnswers[item] === "Yes"}
//                       onChange={() =>
//                         setMinorAnswers({ ...minorAnswers, [item]: "Yes" })
//                       }
//                     />
//                     Yes
//                   </label>

//                   <label>
//                     <input
//                       type="radio"
//                       name={item}
//                       checked={minorAnswers[item] === "No"}
//                       onChange={() =>
//                         setMinorAnswers({ ...minorAnswers, [item]: "No" })
//                       }
//                     />
//                     No
//                   </label>
//                 </div>
//               ))}
//             </div>

//             {/* RIGHT */}
//             <div>
//               <label>Atopic Dermatitis Risk</label>
//               <div>
//                 <label>
//                   <input
//                     type="radio"
//                     checked={atopicRisk === "Yes"}
//                     onChange={() => setAtopicRisk("Yes")}
//                   />
//                   Yes
//                 </label>
//                 <label>
//                   <input
//                     type="radio"
//                     checked={atopicRisk === "No"}
//                     onChange={() => setAtopicRisk("No")}
//                   />
//                   No
//                 </label>
//               </div>

//               <label>Tele-Diagnosis</label>
//               <textarea
//                 value={adTeleDiagnosis}
//                 onChange={(e) => setAdTeleDiagnosis(e.target.value)}
//               />

//               <label>Medical Advice</label>
//               <textarea
//                 value={adMedicalAdvice}
//                 onChange={(e) => setAdMedicalAdvice(e.target.value)}
//               />

//               <label>Recommendations</label>
//               <div className="checkbox-group">
//                 <label>
//                   <input
//                     type="radio"
//                     name="adRecommendation"
//                     checked={adRecommendation === "none"}
//                     onChange={() => setAdRecommendation("none")}
//                   />
//                   No action required
//                 </label>
//                 <label>
//                   <input
//                     type="radio"
//                     name="adRecommendation"
//                     checked={adRecommendation === "followAdvice"}
//                     onChange={() => setAdRecommendation("followAdvice")}
//                   />
//                   Follow Medical Advice
//                 </label>
//                 <label>
//                   <input
//                     type="radio"
//                     name="adRecommendation"
//                     checked={adRecommendation === "consultDerm"}
//                     onChange={() => setAdRecommendation("consultDerm")}
//                   />
//                   Consult Clinical Dermatologist
//                 </label>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* =====================================
//           FOOTER
//       ===================================== */}
//       <div className="derm-footer-actions">
//         {doctor && (
//           <label className="review-checkbox">
//             <input
//               type="checkbox"
//               checked={isReviewed}
//               onChange={(e) => setIsReviewed(e.target.checked)}
//             />
//             Reviewed by Dr. {doctor.name}
//           </label>
//         )}

//         <button
//           className="submit-report-btn"
//           onClick={handleSubmit}
//           disabled={loading}
//         >
//           {loading ? "Submitting..." : "Submit"}
//         </button>

//         <button className="save-draft-btn" onClick={handleReset}>
//           Reset
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DermReportTab;





import React, { useState, useEffect } from "react";
import "../../css/DermReportSection.css";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/axiosConfig";
import { useNavigate } from "react-router-dom";

interface Props {
  emrId: string;
  patientAge: number;
  doctorName: string;
  userId: string;
  sessionId: string;
  showADTab: boolean;
  activeSubTab: "derma" | "ad";
  dermaSubmitted: boolean;
  setDermaSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  adSubmitted: boolean;
  setAdSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
}

const DermReportTab: React.FC<Props> = ({
  emrId,
  patientAge,
  doctorName,
  userId,
  sessionId,
  showADTab,
  activeSubTab,
  dermaSubmitted,
  setDermaSubmitted,
  adSubmitted,
  setAdSubmitted,
}) => {
  const { doctor, currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  /* =====================================
     DERMA STATES
  ===================================== */
  const [dermaTeleDiagnosis, setDermaTeleDiagnosis] = useState("");
  const [dermaMedicalAdvice, setDermaMedicalAdvice] = useState("");
  const [dermaRecommendation, setDermaRecommendation] = useState("");

  /* =====================================
     AD STATES (MANUAL INPUTS)
  ===================================== */
  const [adTeleDiagnosis, setAdTeleDiagnosis] = useState("");
  const [adMedicalAdvice, setAdMedicalAdvice] = useState("");
  const [adRecommendation, setAdRecommendation] = useState("");

  /* =====================================
     COMMON / DB-DRIVEN STATES
  ===================================== */
  const [isReviewed, setIsReviewed] = useState(false);
  const [atopicRisk, setAtopicRisk] = useState<"Yes" | "No" | "">("");
  const [minorAnswers, setMinorAnswers] = useState<Record<string, string>>({});

  // Fetched Major Symptoms
  const [hasPruritus, setHasPruritus] = useState<boolean | null>(null);
  const [hasChronicRelapsing, setHasChronicRelapsing] = useState<boolean | null>(null);
  const [hasTypicalMorphology, setHasTypicalMorphology] = useState<boolean | null>(null);
  const [hasFamilyHistory, setHasFamilyHistory] = useState<boolean | null>(null);
  const [igeCount, setIgeCount] = useState<number | null>(null);

  /* =====================================
     FETCHING DB DATA ON MOUNT
  ===================================== */

  // 1. Fetch Major Symptoms (Health Scores)
  useEffect(() => {
    if (!emrId || activeSubTab !== "ad") return;

    const fetchHealthData = async () => {
      try {
        const res = await api.Questionnair.get(
          `/api/scoring/scoresId/${emrId}/health`
        );
        const results = res?.data?.scores?.resultsById || {};
        const adAnswer = String(results["1220"] || "").toLowerCase();

        setHasChronicRelapsing(adAnswer === "yes" || adAnswer === "maybe");
        setHasPruritus(adAnswer === "yes" || adAnswer === "maybe");
        setHasTypicalMorphology(adAnswer === "yes" || adAnswer === "maybe");
        setHasFamilyHistory(adAnswer === "yes" || adAnswer === "maybe");
      } catch (err) {
        console.error("Failed to fetch major symptoms", err);
      }
    };
    fetchHealthData();
  }, [emrId, activeSubTab]);

  // 2. Fetch Minor Symptoms
  useEffect(() => {
    if (!emrId || activeSubTab !== "ad") return;

    const fetchMinorSymptoms = async () => {
      try {
        const response = await api.dataCollectionApi.get(
          `/api/forms/atopic-dermatitis/${emrId}`
        );

        const features = response?.data?.data?.features || [];
        const newAnswers: Record<string, string> = {};

        // Map backend codes to the exact frontend labels used in the array below
        const keyMapping: Record<string, string> = {
          "facial_pallor": "Erythema",
          "pityriasis_alba": "Pityriasis Alba",
          "darkening_around_the_eyelids": "Darkening around the eyelids",
          "infra_orbital_folds": "Dennie-Morgan Folds",
          "dry_lips": "Cheilitis",
          "anterior_neck_folds": "Anterior Neck-Folds",
          "ichthyosis": "Ichthyosis",
          "increased_palmar_lines": "Hyper linear palms",
          "hand_and_foot_eczema": "Hand and Foot Eczema",
          "nipple_eczema": "Nipple Eczema",
        };

        features.forEach((feature: any) => {
          const label = keyMapping[feature.code];
          if (label) {
            newAnswers[label] = feature.observed === true ? "Yes" : "No";
          }
        });

        setMinorAnswers(newAnswers);
      } catch (error) {
        console.error("Failed to fetch minor symptoms", error);
      }
    };
    fetchMinorSymptoms();
  }, [emrId, activeSubTab]);

  // 3. Fetch IgE Count
  useEffect(() => {
    if (!emrId || activeSubTab !== "ad") return;

    const fetchIgeCount = async () => {
      try {
        const response = await api.dataCollectionApi.get(
          `/api/forms/lab-report/${emrId}`
        );
        const igeValue =
          response?.data?.data?.["Immunoglobulin E (Total IgE)"]?.["Immunoglobulin E"] ?? null;
        setIgeCount(igeValue);
      } catch (error) {
        console.error("Failed to fetch IgE count", error);
      }
    };
    fetchIgeCount();
  }, [emrId, activeSubTab]);

  /* =====================================
     RESET
  ===================================== */
  const handleReset = () => {
    setDermaTeleDiagnosis("");
    setDermaMedicalAdvice("");
    setDermaRecommendation("");

    setAdTeleDiagnosis("");
    setAdMedicalAdvice("");
    setAdRecommendation("");

    setAtopicRisk("");
    setMinorAnswers({});
    setIsReviewed(false);
  };

  /* =====================================
     WORKFLOW
  ===================================== */
  const completeWorkflow = async () => {
    try {
      const doctorId = currentUser?.user?._id;

      if (!doctorId) {
        console.error("Doctor ID is missing from currentUser:", currentUser);
        alert("Doctor ID missing. Please login again.");
        return;
      }

      console.log("COMPLETING WORKFLOW =", sessionId);

      const response = await api.CenterworkflowApi.post(
        `/sessions/${sessionId}/tele-reporting/dermatologist/submit`,
        {
          doctorId,
        }
      );

      console.log("WORKFLOW RESPONSE =", response.data);
      alert("All reports completed successfully");
      handleReset();
      navigate("/queue/dermatology");
      window.location.reload();
    } catch (error) {
      console.error("WORKFLOW ERROR =", error);
      alert("Workflow completion failed");
    }
  };

  /* =====================================
     SUBMIT
  ===================================== */
  const handleSubmit = async () => {
    try {
      const isAD = activeSubTab === "ad";

      /* COMMON VALIDATIONS */
      const teleDiagnosis = isAD ? adTeleDiagnosis : dermaTeleDiagnosis;
      const medicalAdvice = isAD ? adMedicalAdvice : dermaMedicalAdvice;
      const recommendation = isAD ? adRecommendation : dermaRecommendation;

      if (!teleDiagnosis.trim() || !medicalAdvice.trim()) {
        alert("Please enter Tele Diagnosis and Medical Advice");
        return;
      }

      if (!recommendation) {
        alert("Please select recommendation");
        return;
      }

      if (!isReviewed) {
        alert("Please confirm review before submitting.");
        return;
      }

      setLoading(true);

      /* =====================================
         AD PAYLOAD
      ===================================== */
      if (isAD) {
        const adPayload = {
          emrId,
          chartType: "primary",
          // 🔥 NOW USING DYNAMIC STATE DATA INSTEAD OF HARDCODED BOOLEANS
          majorSymptoms: {
            pruritus: !!hasPruritus,
            chronicRelapsing: !!hasChronicRelapsing,
            typicalMorphology: !!hasTypicalMorphology,
            familyHistory: !!hasFamilyHistory,
            igeCount: igeCount !== null ? String(igeCount) : "--",
            allergicRhinitisRisk: !!hasPruritus, 
          },
          minorSymptoms: {
            erythema: minorAnswers["Erythema"] === "Yes",
            pityriasisAlba: minorAnswers["Pityriasis Alba"] === "Yes",
            darkeningAroundEyelids: minorAnswers["Darkening around the eyelids"] === "Yes",
            dennieMorganFolds: minorAnswers["Dennie-Morgan Folds"] === "Yes",
            cheilitis: minorAnswers["Cheilitis"] === "Yes",
            anteriorNeckFolds: minorAnswers["Anterior Neck-Folds"] === "Yes",
            ichthyosis: minorAnswers["Ichthyosis"] === "Yes",
            hyperLinearPalms: minorAnswers["Hyper linear palms"] === "Yes",
            handAndFootEczema: minorAnswers["Hand and Foot Eczema"] === "Yes",
            nippleEczema: minorAnswers["Nipple Eczema"] === "Yes",
          },
          atopicDermatitisRisk: atopicRisk === "Yes",
          teleDiagnosis: adTeleDiagnosis,
          medicalAdvice: adMedicalAdvice,
          recommendations: {
            noActionRequired: adRecommendation === "none",
            followMedicalAdvice: adRecommendation === "followAdvice",
            consultClinicalDermatologist: adRecommendation === "consultDerm",
          },
          reviewedByDoctor: {
            reviewed: isReviewed,
            doctorName: doctor?.name || "",
          },
        };

        console.log("AD PAYLOAD =", adPayload);
        const res = await api.dataCollectionApi.post(
          "/api/teledocs/ad-symptoms",
          adPayload
        );
        console.log("AD RESPONSE =", res.data);
      }
      /* =====================================
         DERMA PAYLOAD
      ===================================== */
      else {
        const dermaPayload = {
          emrId,
          chartType: "primary",
          age: String(patientAge),
          doctorName,
          reportWriting: {
            teleDiagnosis: dermaTeleDiagnosis,
            medicalAdvice: dermaMedicalAdvice,
            recommendation: dermaRecommendation,
          },
          status: "SUBMITTED",
          createdBy: userId,
        };

        console.log("DERMA PAYLOAD =", dermaPayload);
        const res = await api.dataCollectionApi.post(
          "/teledocs/dermatology/hair/report",
          dermaPayload
        );
        console.log("DERMA RESPONSE =", res.data);
      }

      /* =====================================
         SUBMISSION TRACKING
      ===================================== */
      if (activeSubTab === "derma") {
        setDermaSubmitted(true);
        if (showADTab && !adSubmitted) {
          alert("Derma report saved. Please complete AD report.");
          return;
        }
        await completeWorkflow();
      }

      if (activeSubTab === "ad") {
        setAdSubmitted(true);
        if (!dermaSubmitted) {
          alert("AD report saved. Please complete Derma report.");
          return;
        }
        await completeWorkflow();
      }
    } catch (error: any) {
      console.log("ERROR RESPONSE =", error?.response?.data);
      console.error("Submit failed:", error);
      alert("Failed to submit report");
    } finally {
      setLoading(false);
    }
  };

  const getYesNoClass = (val: boolean | null) => {
    if (val === true) return "yes-text";
    if (val === false) return "no-text";
    return "";
  };

  return (
    <div className="report-writing-section">
      <h3 className="summary-title">Report Writing</h3>

      <div className="report-grid">
        {/* =====================================
            DERMA REPORT UI
        ===================================== */}
        {activeSubTab === "derma" && (
          <div className="report-inputs">
            <label>Tele-Diagnosis</label>
            <textarea
              value={dermaTeleDiagnosis}
              onChange={(e) => setDermaTeleDiagnosis(e.target.value)}
            />

            <label>Medical Advice</label>
            <textarea
              value={dermaMedicalAdvice}
              onChange={(e) => setDermaMedicalAdvice(e.target.value)}
            />

            <label>Recommendations</label>
            <div className="checkbox-group">
              <label>
                <input
                  type="radio"
                  name="dermaRecommendation"
                  checked={dermaRecommendation === "none"}
                  onChange={() => setDermaRecommendation("none")}
                />
                No action required
              </label>

              <label>
                <input
                  type="radio"
                  name="dermaRecommendation"
                  checked={dermaRecommendation === "followAdvice"}
                  onChange={() => setDermaRecommendation("followAdvice")}
                />
                Follow Medical Advice
              </label>

              <label>
                <input
                  type="radio"
                  name="dermaRecommendation"
                  checked={dermaRecommendation === "consultDerm"}
                  onChange={() => setDermaRecommendation("consultDerm")}
                />
                Consult Clinical Dermatologist
              </label>
            </div>
          </div>
        )}

        {/* =====================================
            AD REPORT UI
        ===================================== */}
        {activeSubTab === "ad" && (
          <div className="report-inputs ad-grid">
            {/* LEFT */}
            <div>
              <h4>Major Symptoms</h4>
              <ul>
                <li>
                  Pruritus:{" "}
                  <span className={getYesNoClass(hasPruritus)}>
                    {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
                  </span>
                </li>
                <li>
                  Chronic relapsing:{" "}
                  <span className={getYesNoClass(hasChronicRelapsing)}>
                    {hasChronicRelapsing === null ? "--" : hasChronicRelapsing ? "Yes" : "No"}
                  </span>
                </li>
                <li>
                  Typical morphology:{" "}
                  <span className={getYesNoClass(hasTypicalMorphology)}>
                    {hasTypicalMorphology === null ? "--" : hasTypicalMorphology ? "Yes" : "No"}
                  </span>
                </li>
                <li>
                  Family history:{" "}
                  <span className={getYesNoClass(hasFamilyHistory)}>
                    {hasFamilyHistory === null ? "--" : hasFamilyHistory ? "Yes" : "No"}
                  </span>
                </li>
              </ul>

              <p>
                <strong>IgE Count:</strong> {igeCount !== null ? igeCount : "--"}
              </p>
              <p>
                <strong>Allergic Rhinitis Risk:</strong>{" "}
                <span className={getYesNoClass(hasPruritus)}>
                  {hasPruritus === null ? "--" : hasPruritus ? "Yes" : "No"}
                </span>
              </p>
            </div>

            {/* CENTER */}
            <div>
              <h4>Minor Symptoms</h4>
              {[
                "Erythema",
                "Pityriasis Alba",
                "Darkening around the eyelids",
                "Dennie-Morgan Folds",
                "Cheilitis",
                "Anterior Neck-Folds",
                "Ichthyosis",
                "Hyper linear palms",
                "Hand and Foot Eczema",
                "Nipple Eczema",
              ].map((item) => (
                <div key={item} className="yes-no-row">
                  <span>{item}</span>
                  <label>
                    <input
                      type="radio"
                      name={item}
                      checked={minorAnswers[item] === "Yes"}
                      onChange={() =>
                        setMinorAnswers({ ...minorAnswers, [item]: "Yes" })
                      }
                    />
                    Yes
                  </label>

                  <label>
                    <input
                      type="radio"
                      name={item}
                      checked={minorAnswers[item] === "No"}
                      onChange={() =>
                        setMinorAnswers({ ...minorAnswers, [item]: "No" })
                      }
                    />
                    No
                  </label>
                </div>
              ))}
            </div>

            {/* RIGHT */}
            <div>
              <label>Atopic Dermatitis Risk</label>
              <div>
                <label>
                  <input
                    type="radio"
                    checked={atopicRisk === "Yes"}
                    onChange={() => setAtopicRisk("Yes")}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    checked={atopicRisk === "No"}
                    onChange={() => setAtopicRisk("No")}
                  />
                  No
                </label>
              </div>

              <label>Tele-Diagnosis</label>
              <textarea
                value={adTeleDiagnosis}
                onChange={(e) => setAdTeleDiagnosis(e.target.value)}
              />

              <label>Medical Advice</label>
              <textarea
                value={adMedicalAdvice}
                onChange={(e) => setAdMedicalAdvice(e.target.value)}
              />

              <label>Recommendations</label>
              <div className="checkbox-group">
                <label>
                  <input
                    type="radio"
                    name="adRecommendation"
                    checked={adRecommendation === "none"}
                    onChange={() => setAdRecommendation("none")}
                  />
                  No action required
                </label>
                <label>
                  <input
                    type="radio"
                    name="adRecommendation"
                    checked={adRecommendation === "followAdvice"}
                    onChange={() => setAdRecommendation("followAdvice")}
                  />
                  Follow Medical Advice
                </label>
                <label>
                  <input
                    type="radio"
                    name="adRecommendation"
                    checked={adRecommendation === "consultDerm"}
                    onChange={() => setAdRecommendation("consultDerm")}
                  />
                  Consult Clinical Dermatologist
                </label>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* =====================================
          FOOTER
      ===================================== */}
      <div className="derm-footer-actions">
        {doctor && (
          <label className="review-checkbox">
            <input
              type="checkbox"
              checked={isReviewed}
              onChange={(e) => setIsReviewed(e.target.checked)}
            />
            Reviewed by Dr. {doctor.name}
          </label>
        )}

        <button
          className="submit-report-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button className="save-draft-btn" onClick={handleReset}>
          Reset
        </button>
      </div>
    </div>
  );
};

export default DermReportTab;